import { render, staticRenderFns } from "./liveToBeReviewed.vue?vue&type=template&id=4acf35b6"
import script from "./liveToBeReviewed.vue?vue&type=script&lang=js"
export * from "./liveToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./liveToBeReviewed.vue?vue&type=style&index=0&id=4acf35b6&prod&lang=less&scope=true"
import style1 from "./liveToBeReviewed.vue?vue&type=style&index=1&id=4acf35b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports